import * as React from "react";

interface DatePickerProps {
  value: Date;
  onChange: (date: Date) => void;
  min?: Date;
  max?: Date;
}

export default ({ value, min, max, onChange }: DatePickerProps) => {
  return (
    <input
      type="date"
      value={dateToValue(value)}
      min={dateToValue(min)}
      max={dateToValue(max)}
      onChange={(e) => onChange(valueToDate(e.target.value))}
    />
  );
};

const dateToValue = (date?: Date): string | undefined =>
  date === undefined ? undefined : date.toISOString().split("T")[0];
const valueToDate = (value: string): Date => new Date(value);
